<template>
    <q-btn :loading="loading" :flat="flat" :dense="dense" :round="round"
           :rounded="rounded" :no-caps="noCaps" :size="size"
           link
           :label="label"
           :type="type"
           :color="color"
           :icon="icon"
           :icon-right="iconRight"
           :disable="disable" @click="$emit('click', $event); if (to) $router.push(to)"
           :prevent-keyboard="preventKeyboard"
           class="super-hover">
        <slot></slot>
        <template v-if="$slots.loading">
            <slot name="loading" slot="loading"></slot>
        </template>
    </q-btn>
</template>

<script>
    import {
        QBtn
    } from 'quasar-framework'

    export default {
        name: 'VButton',

        props: {
            label: String,
            outline: Boolean,
            small: Boolean,
            dense: Boolean,
            flat: Boolean,
            round: Boolean,
            rounded: Boolean,
            size: {
                type: String,
                default: 'md'
            },
            noCaps: Boolean,
            disable: Boolean,
            color: {
                type: String,
                default: 'primary'
            },
            icon: String,
            iconRight: String,
            type: {
                type: String,
                default: 'button'
            },
            loading: Boolean,
            to: [String, Object],
            preventKeyboard: Boolean
        },

        components: {
            QBtn
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VButton.vue